export default __webpack_public_path__ + "static/wealcome-projects-78b08c274c74fd264bdc10e105c2bfa8.svg";